import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import CheckCircle from 'material-ui/svg-icons/action/check-circle'
import ReviewResponse from '../../sitewide/Reviews/ReviewResponse'
import RequestReviewButtons from '../../sitewide/Reviews/RequestReviewButtons'
import css from './appointments.css'

const AppointmentRow = ({
  appointment,
  appointment: {
    id,
    appointment_datetime: apptDatetime,
    appointment_type_code: code,
    appointment_type_description: description,
    review,
    confirmed,
    status,
    doctor,
  },
  hasReviews,
  requestReview,
}) => {
  const doctorName = !!doctor ? doctor.preferred_name : null
  const datetime = moment(apptDatetime)
  const apptCodeAndDescription = [code, description].filter(n => n).join(': ')
  const listStyle = (apptCodeAndDescription || hasReviews) ?
    css.appointmentWithDescription :
    css.appointment
  return (
    <li
      className={listStyle}
      key={id}
    >
      <div className={css.appointmentFirstRow}>
        <span className={css.time}>
          {datetime.format('h:mma')}
        </span>
        <span className={css.date}>
          {datetime.format('MMM Do, YYYY')}
        </span>
        <span className={css.doctor}>
          {doctorName}
        </span>
        {hasReviews && (
          <div className={apptCodeAndDescription ? css.reviewsWithDescription : css.reviews}>
            {!review && (
              <div className={css.requestReview}>
                <RequestReviewButtons
                  appointment={appointment}
                  requestReview={requestReview}
                />
              </div>
            )}
            {review && <ReviewResponse review={review} />}
          </div>
        )}
        <span className={css.status}>
          {status}
        </span>
        <span className={css.confirmed}>
          {confirmed && <CheckCircle />}
        </span>
      </div>
      {!!apptCodeAndDescription &&
        <div className={css.appointmentType}>
          <span>
            {apptCodeAndDescription}
          </span>
        </div>
      }
    </li>
  )
}

AppointmentRow.propTypes = {
  appointment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    appointment_datetime: PropTypes.string.isRequired,
    appointment_type_code: PropTypes.string,
    appointment_type_description: PropTypes.string,
    review: PropTypes.object,
    confirmed: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    doctor: PropTypes.shape({
      preferred_name: PropTypes.string.isRequired,
    }),
  }),
  hasReviews: PropTypes.bool.isRequired,
  requestReview: PropTypes.func.isRequired,
}

export default AppointmentRow



// WEBPACK FOOTER //
// ./src/components/PatientPage/Appointments/AppointmentRow.js